import { AtomChannels, AtomTopics } from '@client/core/atoms/consts.js';
import { atom } from '@podium/store';
import type {
  RetailMediaPlacement,
  LayoutType,
  SearchParams,
  SearchMetadata
} from '@schibsted-nmp/advertising-shared';

type RetailMediaEventType = 'layout_change' | 'search_change' | 'init';

type RetailMediaAtom = {
  placements: Array<RetailMediaPlacement>;
  searchParams?: SearchParams | undefined;
  layoutType?: LayoutType | undefined;
  eventType?: RetailMediaEventType;
  metadata?: SearchMetadata;
};

export const $retailMediaAtom = atom<$retailMediaAtom.Value>(
  AtomChannels.Podlet,
  AtomTopics.RetailMedia,
  {
    placements: [],
    searchParams: undefined,
    layoutType: undefined,
    eventType: 'init'
  }
);

export namespace $retailMediaAtom {
  export type Value = RetailMediaAtom;
}
